<template>
  <q-page padding>
    <PageHeader
      title="Requisição Balcão"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-4 input-unidade-container">
        <div class="q-ml-sm no-margin-no-padding titulo-input-unidade">
          Unidade
        </div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade"
          :error="unidadeObrigatoria"
        ></lista-unidades-select>
      </div>
      <div
        v-if="tipoRequisicao == 'balcao'"
        @click.capture="verificarUnidade"
        class="col-2 input-colaborador-container"
      >
        <div class="col-md col-xs-4 no-margin-no-padding titulo-input-unidade">
          Requisição Para
        </div>
        <q-select
          class="input-new-design"
          dense
          outlined
          v-model="requisicaoPara"
          :options="options"
        />
      </div>
      <div
        v-if="temPermissaoCracha() && requisicaoPara.value == 'colaborador'"
        @click.capture="verificarUnidade"
        class="col-md col-xs-4"
      >
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          :resetar="resetarFuncionario"
          debounce="500"
          :buscarPorCracha="true"
          :vendor-id="unidade?.id"
        />
      </div>
      <div
        v-if="requisicaoPara.value == 'colaborador'"
        class="col-md col-xs-3"
        @click.capture="verificarUnidade"
      >
        <div class="texto-titulo-input">Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          @emitirFuncionario="receberFuncionario"
          :resetar="resetarFuncionario"
          :vendor-id="unidade?.id"
        />
      </div>
      <div v-if="requisicaoPara.value != 'visitante'" class="col-md col-xs-3">
        <div class="texto-titulo-input">Centro de Custo</div>

        <q-input
          v-model="centroCustoUsuario"
          dense
          outlined
          bg-color="brand-7"
          class="select input-new-design"
          disable
        />
      </div>
      <div
        v-if="requisicaoPara.value == 'visitante'"
        @click.capture="verificarUnidade"
        class="col-md-2 col-sm-6 col-xs-6 q-ml-xs"
      >
        <div class="texto-titulo-input">Centro de Custo</div>
        <SelecaoCentroCustos v-model="centroCusto" />
      </div>
      <div class="col-md col-xs-3" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Saldo Estoque</div>
        <q-select
          v-model="saldo"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          option-label="label"
          :options="saldoOptionsFiltered"
          :disable="isSaldoSelectDisabled"
          :bg-color="isSaldoSelectDisabled ? 'brand-7' : undefined"
          class="select input-new-design"
        />
      </div>
      <div
        v-if="temPermissaoFiltroPorGrupo()"
        class="col-md col-xs-3"
        @click.capture="verificarUnidade"
      >
        <div class="texto-titulo-input">Grupo de Produto</div>
        <q-select
          label="Selecione o Grupo"
          dense
          outlined
          class="input-new-design"
          input-debounce="500"
          v-model="grupoSelecionado"
          :options="listaGrupo"
          @filter="filtrarGrupo"
          fill-input
          use-input
          hide-selected
          label-color="grey-6"
          option-label="name"
        />
      </div>
    </div>

    <div class="row col-12 q-my-xl" @click.capture="verificarUnidade">
      <div
        class="column col-4 text-brand-5 no-margin-no-padding text-weight-regular input-tipo-requisicao-container"
      >
        <div
          style="font-weight: 100; font-size: 16px"
          class="text-weight-bold text-brand-1 titulo-input-tipo-requisicao"
        >
          Selecione a condição dos produtos que serão listados
        </div>
        <div class="row q-mt-sm radio-container">
          <q-radio
            val="all"
            label="Todos"
            v-model="filtroTipoRequisicao"
            :disable="
              carregandoProdutos ||
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-produto-todos'
              ) != -1
            "
          ></q-radio>
          <q-radio
            v-if="
              requisicaoPara.value == 'colaborador' ||
              tipoRequisicao == 'requisicaoMaterial'
            "
            val="liberados"
            label="Produtos Liberados"
            v-model="filtroTipoRequisicao"
            :disable="
              carregandoProdutos ||
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-produto-liberados'
              ) != -1
            "
          ></q-radio>
          <q-radio
            v-if="requisicaoPara.value != 'visitante'"
            val="yes"
            label="Todos EPI"
            v-model="filtroTipoRequisicao"
            :disable="
              carregandoProdutos ||
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-produto-epis'
              ) != -1
            "
          ></q-radio>
        </div>
      </div>
    </div>

    <div v-show="unidade?.id">
      <NovaRequisicaoTabelas
        :key="componentKey"
        :unidade="unidade.id"
        :filtroTipoRequisicao="filtroTipoRequisicao"
        :tipoRequisicao="tipoRequisicao"
        :requisicaoPara="requisicaoPara.value"
        :solicitantePesquisaProp="solicitantePesquisa"
        :solicitanteMatriculaProp="solicitanteMatricula"
        :centroSelecionadoProps="centroCusto"
        @listaSolicitantes="getListaSolicitante"
        @loadingProdutos="(val) => (carregandoProdutos = val)"
        :tipoSaldo="saldo"
        :grupoId="grupoSelecionado?.id || undefined"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import NovaRequisicaoTabelas from "../components/NovaRequisicaoTabelas.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";
import SelecaoCentroCustos from "../components/SelecaoCentroCustos.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  name: "NovaRequisicao",
  components: {
    NovaRequisicaoTabelas,
    ListaUnidadesSelect,
    SelecaoFuncionario,
    SelecaoCentroCustos,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const ativo2 = ref(true);
    const unidadeObrigatoria = ref(false);
    const carregandoProdutos = ref(false);
    let unidade = ref("");
    let filtroTipoRequisicao = ref(null);
    const solicitanteMatricula = ref(null);
    const solicitantePesquisa = ref(null);
    const listarSolicitantes = ref([]);
    const saldo = ref("");
    const resetarFuncionario = ref(0);
    const centroCusto = ref(null);
    const tipoRequisicao = ref("balcao");
    const centroCustoUsuario = ref(null);
    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);
    const componentKey = ref(0);
    const options = ref([
      {
        label: "Colaborador",
        value: "colaborador",
      },
      {
        label: "Visitante",
        value: "visitante",
      },
    ]);
    let requisicaoPara = ref({
      label: options.value[0].label,
      value: options.value[0].value,
    });

    watch(
      () => unidade.value,
      (novoValor) => {
        if (novoValor?.id) {
          unidadeObrigatoria.value = false;
        }
      }
    );

    const verificarUnidade = (event) => {
      if (!unidade.value?.id) {
        event.stopPropagation();
        event.preventDefault();
        unidadeObrigatoria.value = true;
        quasar.notify({
          message: "O campo Unidade é obrigatório para seguir com a requisição",
          color: "negative",
          position: "bottom",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
        if (temPermissaoFiltroPorGrupo()) {
          listarGrupo();
        }
      }
    );

    watch(
      () => requisicaoPara.value,
      (newValue, oldValue) => {
        if (newValue.value == "visitante") {
          filtroTipoRequisicao.value = "all";
          solicitanteMatricula.value = "";
          solicitantePesquisa.value = "";
        }

        if (
          oldValue &&
          oldValue.value == "visitante" &&
          newValue.value == "colaborador"
        ) {
          filtroTipoRequisicao.value = null;
          solicitanteMatricula.value = null;
          solicitantePesquisa.value = null;
          centroCustoUsuario.value = null;

          componentKey.value++;
        }

        resetarFuncionario.value++;
      }
    );

    watch(
      () => filtroTipoRequisicao.value,
      (novoTipo, tipoAnterior) => {
        if (
          tipoAnterior === "liberados" &&
          (novoTipo === "all" || novoTipo === "yes") &&
          deveMostrarLiberadosDefault()
        ) {
          quasar
            .dialog({
              title: "⚠️ Confirmação de Mudança",
              message:
                "Tem certeza que deseja alterar a seleção? As entregas devem ser feitas primariamente pela opção 'Produtos Liberados', que já estava selecionada.",
              cancel: {
                label: "Manter",
                color: "primary",
                style: "width: 47%",
              },
              persistent: true,
              ok: {
                label: "Alterar",
                color: "negative",
                style: "width: 47%",
              },
            })
            .onCancel(() => {
              filtroTipoRequisicao.value = "liberados";
            });
        }
      }
    );

    const getListaSolicitante = (lista) => {
      listarSolicitantes.value = lista.map((e) => {
        return { labelBase: `${e.name} - ${e.email}`, ...e };
      });
    };

    const receberFuncionario = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;

      centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;

      if (deveMostrarLiberadosDefault()) {
        filtroTipoRequisicao.value = "liberados";
      }
    };

    const receberFuncionarioPorCracha = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;

      centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;

      if (deveMostrarLiberadosDefault()) {
        filtroTipoRequisicao.value = "liberados";
      }
    };

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch("requisicao/listarFuncionarios", {
          card_id: card_id,
          vendor_id: unidade.value?.id,
        });

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionario(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    const temPermissaoFiltroPorGrupo = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "filtrar_grupo_produto_em_requisicao"
        ) || false
      );
    };

    const temPermissaoProdutosLiberadosDefault = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "requisicao-produtos-liberados-default"
        ) || false
      );
    };

    const deveMostrarLiberadosDefault = () => {
      return (
        store.state.autenticacao.cliente.includes("acciona") ||
        store.state.autenticacao.cliente.includes("staging-acciona") ||
        temPermissaoProdutosLiberadosDefault()
      );
    };

    const listaGrupo = ref([]);
    const grupoSelecionado = ref({ name: "Todos", id: "" });

    const listarGrupo = async (search) => {
      try {
        const response = await store.dispatch("requisicao/listarGrupos", {
          per_page: 10,
          vendor_id: unidade.value?.id,
          search: search,
        });
        listaGrupo.value = response.data.results.data;
        if (search == "" || search == undefined) {
          listaGrupo.value.unshift({ name: "Todos", id: "" });
        }
      } catch (error) {
        console.log(error);
      }
    };

    function filtrarGrupo(val, update) {
      listarGrupo(val);
      setTimeout(() => {
        update();
      }, 500);
    }

    const temPermissaoComSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-com-saldo"
        ) || false
      );
    });

    const temPermissaoSemSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-sem-saldo"
        ) || false
      );
    });

    const isSaldoSelectDisabled = computed(() => {
      return temPermissaoComSaldo.value || temPermissaoSemSaldo.value;
    });

    const saldoOptionsFiltered = computed(() => {
      if (temPermissaoComSaldo.value) {
        return [{ label: "Com Saldo", value: "com-saldo" }];
      }
      if (temPermissaoSemSaldo.value) {
        return [{ label: "Sem Saldo", value: "sem-saldo" }];
      }
      return [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ];
    });

    const inicializarSaldoBasedoNasPermissoes = () => {
      if (temPermissaoComSaldo.value) {
        saldo.value = "com-saldo";
      } else if (temPermissaoSemSaldo.value) {
        saldo.value = "sem-saldo";
      } else {
        saldo.value =
          store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona")
            ? "com-saldo"
            : "";
      }
    };

    onMounted(() => {
      inicializarSaldoBasedoNasPermissoes();
      if (temPermissaoFiltroPorGrupo()) {
        listarGrupo();
      }
    });

    return {
      unidade,
      ativo2,
      filtroTipoRequisicao,
      tipoRequisicao,
      options,
      requisicaoPara,
      solicitanteMatricula,
      solicitantePesquisa,
      receberFuncionario,
      receberFuncionarioPorCracha,
      resetarFuncionario,
      centroCusto,
      filterFn(val, update) {
        solicitantePesquisa.value = val;
        setTimeout(() => {
          update();
        }, 300);
      },
      listarSolicitantes,
      getListaSolicitante,
      centroCustoUsuario,
      saldoOptions: [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ],
      saldo,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      buscarPorCracha,
      temPermissaoCracha,
      temPermissaoFiltroPorGrupo,
      temPermissaoProdutosLiberadosDefault,
      listaGrupo,
      grupoSelecionado,
      filtrarGrupo,
      saldoOptionsFiltered,
      isSaldoSelectDisabled,
      componentKey,
      unidadeObrigatoria,
      verificarUnidade,
      carregandoProdutos,
    };
  },
};
</script>

<style scoped>
.ativo {
  color: white !important;
  background-color: #2d3e6e !important;
  border-radius: 3px;
}
.ativo2 {
  color: white !important;
  background-color: #2b5070 !important;
  border-radius: 3px;
}

.titulo-input-tipo-requisicao {
  font-size: 18px;
}

.radio-margin-top {
  margin-top: 36px;
}

@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .input-unidade-container,
  .input-colaborador-container {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
    padding: 0;
  }

  .col-md,
  .col-2 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .row-input-container {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .input-tipo-requisicao-container {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-top: 20px;
    padding: 0;
  }

  .radio-container {
    flex-direction: column !important;
  }

  .radio-container .q-radio {
    margin-bottom: 12px;
  }

  .titulo-input-unidade,
  .texto-titulo-input,
  .texto-titulo-select {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .titulo-input-tipo-requisicao {
    font-size: 14px !important;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .no-margin-no-padding {
    padding: 0;
    margin: 0;
  }

  .q-ml-xs {
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .titulo-input-tipo-requisicao {
    font-size: 13px !important;
  }

  .q-page {
    padding: 8px !important;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
